import { DefaultCustomItemOptions } from '@/components/documents/CustomItems/DefaultCustomItemOptions'
import { PbProductType } from '@/enums/PbProductType'
import { PbSubcategory } from '@/enums/PbSubcategory'

export const NorthCarolinaCustomItems = {
	...DefaultCustomItemOptions,
	[PbProductType.Service]: {
		[PbSubcategory.ServiceBasicServicesOfFDAndStaff]: [],
		[PbSubcategory.ServiceEmbalming]: [],
		[PbSubcategory.ServiceRefrigeration]: [],
		[PbSubcategory.ServiceOtherBodyPreparation]: [],
		[PbSubcategory.ServiceVisitationViewing]: [],
		[PbSubcategory.ServiceFuneralMemorial]: [],
		[PbSubcategory.ServiceGravesideService]: [],
		[PbSubcategory.ServiceMemorialService]: [],
		[PbSubcategory.ServiceForwardingRemains]: [],
		[PbSubcategory.ServiceReceivingRemains]: [],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Discount]: [],
	},
	[PbProductType.Transportation]: {
		[PbSubcategory.TransportationTransfer]: [
			{
				prop: 'mileRadiusForStandardService',
				label: 'Mile Radius for Standard Service',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.TransportationHearse]: [],
		[PbSubcategory.TransportationFamilyCarLimo]: [],
		[PbSubcategory.Other]: [],
	},
	[PbProductType.Merchandise]: {
		[PbSubcategory.MerchandiseCasket]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
			{
				prop: 'interiorDescription',
				label: 'Interior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseOuterBurialContainer]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.MerchandiseUrn]: [
			{
				prop: 'productManufacturer',
				label: 'Product Manufacturer',
				type: 'text',
				required: false,
			},
			{
				prop: 'modelNameNumber',
				label: 'Model Name/Number',
				type: 'text',
				required: false,
			},
			{
				prop: 'exteriorDescription',
				label: 'Exterior Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Discount]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.CashAdvance]: {
		[PbSubcategory.CashAdvanceDeathCertificates]: [],
		[PbSubcategory.CashAdvanceObituary]: [],
		[PbSubcategory.CashAdvanceFlowers]: [],
		[PbSubcategory.CashAdvanceCremationServices]: [],
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
		[PbSubcategory.Discount]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
	[PbProductType.Cemetery]: {
		[PbSubcategory.Other]: [],
	},
	[PbProductType.Disposition]: {
		[PbSubcategory.DispositionDirectCremation]: [],
		[PbSubcategory.DispositionDirectBurial]: [],
	},
	[PbProductType.Other]: {
		[PbSubcategory.Other]: [
			{
				prop: 'shortDescription',
				label: 'G&S Description',
				type: 'text',
				required: false,
			},
		],
	},
}
